module.exports = __webpack_public_path__ + "static/media/nring.feca2d44.mp3";